import "easy-autocomplete";

export default function () {
    var elements = document.querySelectorAll('[data-autocomplete-method]');

    for (var inc = 0; inc < elements.length; ++inc) {
        var element = elements[inc];
        var options = {
            url: function (phrase) {

                let url = $("body").data("approot")+
                "/panel/methods/autocomplete?method="
                + element.getAttribute("data-autocomplete-method")
                + "&phrase=" + phrase;
               
                return url;
               
            },
            requestDelay: 500,
            getValue: "entered",
            list: {
                onChooseEvent: function () {
                    var item = $(element).getSelectedItemData();

                    if (item && item.id) {
                        $("#SelectedProductId").val(item.id).trigger("change");
                        __doPostBack();
                    }
                }
            },
            template: {
                type: "custom",
                method: function (value, item) {
                    if (item.link)
                        return "<img src='" + item.icon + "' /> <a href='" + item.link + "'>  " + item.text + "</a><small>" + item.additional + "</small>";
                    else return "<div><img src='" + item.icon + "' />  " + item.text + "<small>" + item.additional + "</small></div>";
                }
            }
        };

        $(element).easyAutocomplete(options);
    }
}